module.exports = __webpack_public_path__ + "static/img/user_info_gray.35f6933.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_info_gray.svg
// module id = P+e/
// module chunks = 1